import { Component, OnInit } from '@angular/core';
import { Produit } from 'src/app/entity/Facture';
import { FactureService } from 'src/app/service/facture.service';
import { Observable } from 'rxjs';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-produits',
  templateUrl: './produits.component.html',
  styleUrls: ['./produits.component.css']
})
export class ProduitsComponent implements OnInit {

  loading:boolean;
  isVisible:boolean;
  ouiNon: SelectItem[];
produitsObservable:Observable<Produit[]>;
  produits: Produit[];
  selectedProduit: Produit;
 cols = [
      { field: 'designation', header: 'Designation FR' ,width:'40%'} , 
      { field: 'designationAn', header: 'Designation EN',width:'30%' } ,
      { field: 'specifique', header: 'Materiel spécifique',width:'20%' } ,
      { field: 'publicite', header: 'Publicité' ,width:'10%' },
      { field: 'prixDzd', header: 'Prix Dinars' ,width:'10%' },
      { field: 'prixDol', header: 'Prix Dollar' ,width:'10%' },

      { field: 'prixEuro', header: 'Prix Euro' ,width:'10%' },
  ];

 // [ngStyle]="{'background-color': (selectedProduit) &&  (rowData.sociFactId === selectedProduit.sociFactId) ? '#ef8b00' :'white'  }"


  constructor(private produitService:FactureService) { }

  ngOnInit() {
    
    this.findAll()
    this.ouiNon = [
      { label: 'Oui', value: true },
      { label: 'Non', value: false },
 
  ];
  }
  prepareProduit(){
    this.selectedProduit=new Produit()
    this.isVisible=true;
  }
  saveProduit(){
    if(this.selectedProduit.produitId)
    this.produitService.editProduit(this.selectedProduit).subscribe(result=>{
this.findAll()
    })
    else
 this.produitService.addProduit(this.selectedProduit).subscribe(result=>{
  this.findAll()
 })
  }
  findAll() {
    this.produitsObservable= this.produitService.getAllProduits();
  this.produitsObservable.subscribe(result=>{
    this.produits =result
  })
  this.isVisible=false;
  }
  removeProduit(){
    this.produitService.removeProduit(this.selectedProduit).subscribe(result=>{
      this.findAll()
     })
  }
}
